/**
 * Emit a tag to Facebook
 *
 * @param {String} tag Event label to send to Facebook
 */
function track(...params) {
    if (typeof window.fbq !== 'function') {
        return;
    }
    window.fbq(...params);
}

export default {
    track,
};
